export default "__VITE_ASSET__CnFIiXB5__"